"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseCloseButton } from "../ModalBase/ModalBaseCloseButton.mjs";
import { useModalContext } from "./Modal.context.mjs";
import Modal_module_default from "./Modal.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalCloseButton.tsx
const ModalCloseButton = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ModalCloseButton", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseCloseButton, {
		...useModalContext().getStyles("close", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
ModalCloseButton.classes = Modal_module_default;
ModalCloseButton.displayName = "@mantine/core/ModalCloseButton";
//#endregion
export { ModalCloseButton };

//# sourceMappingURL=ModalCloseButton.mjs.map